<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="128.000000pt"
    height="128.000000pt"
    viewBox="0 0 128.000000 128.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M1080 1196 c-71 -25 -85 -45 -45 -66 30 -16 32 -31 5 -55 -19 -17
-23 -16 -120 19 -56 20 -109 36 -118 36 -8 0 -65 -31 -126 -70 l-111 -69 -75
19 c-93 24 -90 24 -90 0 0 -14 11 -22 43 -30 23 -6 55 -15 71 -20 49 -17 62
-12 177 61 l113 71 114 -43 115 -42 35 38 35 38 29 -18 c41 -24 49 -11 46 76
-4 87 -5 88 -98 55z"
      />
      <path
        d="M727 964 c-4 -4 -7 -112 -7 -241 l0 -233 80 0 80 0 -2 238 -3 237
-70 3 c-39 1 -74 0 -78 -4z m113 -234 l0 -200 -40 0 -40 0 0 200 0 200 40 0
40 0 0 -200z"
      />
      <path
        d="M957 924 c-4 -4 -7 -103 -7 -221 l0 -213 80 0 80 0 -2 218 -3 217
-70 3 c-39 1 -74 0 -78 -4z m113 -219 l0 -175 -40 0 -40 0 0 175 0 175 40 0
40 0 0 -175z"
      />
      <path
        d="M490 795 c0 -58 2 -65 20 -65 17 0 20 7 20 45 l0 45 40 0 40 0 0 -49
c0 -40 3 -50 20 -54 19 -5 20 0 20 69 l0 74 -80 0 -80 0 0 -65z"
      />
      <path
        d="M202 710 c-45 -10 -90 -56 -98 -98 -5 -24 2 -70 20 -143 15 -59 31
-149 36 -201 15 -150 46 -212 104 -206 42 4 64 41 81 137 15 85 27 111 51 111
20 0 30 -26 48 -119 19 -100 36 -131 74 -131 65 0 97 64 109 220 3 47 17 121
29 164 14 44 24 106 24 139 0 54 -3 62 -34 93 -31 31 -39 34 -95 34 -33 0 -83
-5 -112 -11 -39 -8 -67 -8 -113 1 -33 7 -68 13 -76 15 -8 1 -30 -1 -48 -5z
m188 -54 c47 1 111 3 143 5 52 4 61 1 78 -20 25 -30 24 -78 -1 -166 -11 -39
-25 -119 -31 -180 -10 -106 -31 -175 -55 -182 -11 -4 -17 14 -44 149 -28 142
-151 128 -180 -19 -21 -112 -26 -127 -38 -131 -20 -6 -42 62 -53 170 -5 57
-22 147 -35 201 -15 55 -23 109 -20 123 10 39 63 67 111 57 22 -4 78 -7 125
-7z"
      />
      <path
        d="M720 420 c0 -19 7 -20 230 -20 223 0 230 1 230 20 0 19 -7 20 -230
20 -223 0 -230 -1 -230 -20z"
      />
    </g>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
